import _ from "lodash";
import React from "react";
import ClientReportsTableHeader from "./components/ClientReportsTableHeader";
import ClientReportTableRow from "./components/ClientReportTableRow";
import { useClientReportsList } from "../../hooks/ClientReportContext";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";

const ClientReportsTable = () => {
    const { 
        clear: refreshTable,
        data,
        error,
        isLoading,
        isNextPageLoading,
        isNewRecords,
        isRowLoaded,
        loadMore,
        newRecordsSinceCache,
        totalCount
    } = useClientReportsList()!;

    const isNewRecordsDisplayed = isNewRecords && !isLoading && !isNextPageLoading;
    return (
        <VirtualTable 
            enableScrollTracking={false}
            row={ClientReportTableRow}
            header={(
                <thead>
                    <tr>
                        <ClientReportsTableHeader property="reportName">Report Name</ClientReportsTableHeader>
                        <ClientReportsTableHeader property="projectName">Project</ClientReportsTableHeader>
                        <ClientReportsTableHeader property="status">Status</ClientReportsTableHeader>
                        <ClientReportsTableHeader property="authorName">Author</ClientReportsTableHeader>
                        <ClientReportsTableHeader className="text-center" property="efficacy">Quality</ClientReportsTableHeader>
                        <ClientReportsTableHeader property="complianceOfficerName">Compliance</ClientReportsTableHeader>
                        <ClientReportsTableHeader property="compliantDate">Compliant</ClientReportsTableHeader>
                        <ClientReportsTableHeader property="sentDate">Sent</ClientReportsTableHeader>
                        <ClientReportsTableHeader property="createdDate">Created</ClientReportsTableHeader>
                        <th className="sticky-header">&nbsp;</th>
                    </tr>
                </thead>
            )}
            footer={
                <TableRecordCountDisplayFooter 
                    totalCount={totalCount}
                    isNewRecordsDisplayed={isNewRecordsDisplayed}
                    newRecordsSinceCache={newRecordsSinceCache}
                    reload={refreshTable}
                />
            }
            error={error}
            isLoading={isNextPageLoading}
            isItemLoaded={isRowLoaded}
            loadMoreItems={loadMore}
            itemSize={48.7}
            itemCount={totalCount}
            itemData={data}
        />
    );
}

export default ClientReportsTable;